/**
 * Customer reviews supplied and approved by EPO (Sept 2026).
 * Names shown as first name + initial, with city only.
 */
export type Review = {
  name: string;
  city: string;
  service: string;
  quote: string;
  rating: 5;
};

export const reviews: Review[] = [
  {
    name: "Holly A.",
    city: "Denver",
    service: "Panel replacement",
    rating: 5,
    quote:
      "Great experience from start to finish! The team did an excellent job replacing our electrical panel. They were professional, knowledgeable, on time, and took the time to answer our questions and explain everything clearly. The work was completed efficiently and everything was left clean when they were finished. It's nice to work with a company that is reliable and takes pride in their work. I would definitely recommend them to anyone needing electrical panel work!",
  },
  {
    name: "Jim D.",
    city: "Littleton",
    service: "Repeat customer, four years",
    rating: 5,
    quote:
      "We've been using Burke for about four years for various projects around our home, including ceiling fans, outlets, and other electrical work. Always reliable, professional, and does great work. Definitely recommend!",
  },
  {
    name: "The Hayes",
    city: "Denver",
    service: "Whole-house remodel electrical",
    rating: 5,
    quote:
      "We used this company for all of the electrical during our whole-house remodel and had a great experience. They were professional, reliable, easy to work with, and did quality work throughout the entire project. Would definitely recommend them for any electrical or remodeling project!",
  },
  {
    name: "Whispering Pines HOA",
    city: "Denver",
    service: "Community-wide electrical project",
    rating: 5,
    quote:
      "We used this company for a large electrical project throughout our HOA and had a great experience. They were professional, organized, communicated well with homeowners, and kept the project running smoothly from start to finish. Quality work and very reliable. Highly recommend!",
  },
];
